import { Loader } from '@/components/ui/loader/loader.component';

export const RedirectPage = () => {
  return (
    <div className="w-full h-full">
      <Loader fullWidth />
    </div>
  );
};
